// import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="bg-white bg-opacity-20 px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-primary sm:text-5xl">
            404
          </p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                Halaman Tidak Ditemukan
              </h1>
              <p className="mt-1 text-base text-gray-500">
                Halaman yang Anda cari tidak ditemukan, periksa kembali URL
                Anda.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default NotFoundPage;
